module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#premium",
      toString: function () {
        return this.url;
      }
    }